import * as React from 'react'
import { BtcInfoContext } from '../general/SatoshiPriceProvider';
import { TerminalNodeInterpreter } from './model/TerminalNodeInterpreter';
import { TerminalScoreContext } from './TerminalScoreProvider';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TerminalNodeStatus from './TerminalNodeStatus';

type Props = {
  nodeId: string,
  className?: string
}

const TerminalOverview: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);
  const terminalNode = terminalScore.getNode(nodeId);
  const interpreter = new TerminalNodeInterpreter(terminalNode);

  React.useEffect(() => {
    console.log('node', terminalNode, 'rank', rank);
  }, []);
  if (!terminalNode) {
    return <React.Fragment/>
  }
  const status = terminalScore.getNodeStatus(nodeId);
  const rank = terminalScore.getNodeRank(nodeId);



  return (
    <div className={'bg-viking-900 text-white ' + className}>
      <div className="flex flex-col md:flex-row justify-around items-center    py-6 px-4 container mx-auto">
        <div className="text-2xl pr-1 py-4">
          <div>
            {terminalNode?.alias &&
            terminalNode.alias
            }
          </div>
          <div className="text-xs text-right">
            <a href={"https://terminal.lightning.engineering/#/" + nodeId} target="_blank" title="Open on Terminal Web">
              <span className="underline text-viking-700 hover:text-viking-500">Open Terminal Web</span>
            </a>
          </div>

        </div>
        <div className="py-4">
          <TerminalNodeStatus status={status} />
        </div>

        <div className="py-4 md:pr-4 text-viking-100">
          <div className="text-2xl text-center">
            {rank === -1 && '-'}
            {rank > 0 && rank}
          </div>
          <div className="text-viking-700 break-words">
            Rank
          </div>

        </div>

        <div className="py-4 md:pr-4 text-viking-100">
          <div className="text-2xl text-center">
            {terminalScore.getCentralityPercentile(nodeId)}th
          </div>
          <div className="text-viking-700 break-words">
            Percentile centrality
          </div>

        </div>
        <div className="md:pr-4 py-4">
          <div className="text-2xl text-center">
            {interpreter.isStable &&
              interpreter.goodPeers.length
            }
            {!interpreter.isStable &&
              '-'
            }

          </div>
          <div className="text-viking-700 break-words">
            Good peers
          </div>

        </div>

      </div>

    </div>
  );
}

export default TerminalOverview;

